import React from "react";
import { useNavigate } from "react-router-dom";
import Heading from "../../components/Heading";
import { FaTrophy, FaMusic, FaMedal } from "react-icons/fa";

const SelectionPage = () => {
  return (
    <main className="h-screen w-screen overflow-x-hidden lg:overflow-y-hidden flex flex-col lg:flex-row">
      <PrimarySection />
      <SelectionSection />
    </main>
  );
};

const PrimarySection = () => {
  return (
    <section className="lg:p-8 bg-white h-full w-full lg:w-5/12">
      <div className="bg-gradient-to-b from-ming to-pacific p-8 lg:rounded-xl shadow-xl h-full flex flex-col justify-between">
        <header className="flex space-x-4 items-center pb-4">
          <img
            src="https://upload.wikimedia.org/wikipedia/en/e/eb/PSG_College_of_Technology_logo.png"
            alt="PSG Tech Logo"
            className="h-12 lg:h-16 w-auto filter invert"
          />
          <div className="text-white font-poppins">
            <p className="text-xl lg:text-2xl">PSG College of Technology</p>
            <p className="text-sm">Coimbatore</p>
          </div>
        </header>
        <div>
          <h1 className="text-white font-poppins text-4xl mt-8">
            Apply for Best Outgoing, Tekmusic & Sports Awards{" "}
            {new Date().getFullYear()}
          </h1>
          <h2 className="text-white font-poppins text-base mt-4 tracking-wide">
            Select the category you wish to apply for from the options.
          </h2>
        </div>
        <div className="rounded-lg bg-ming lg:p-8 p-4 font-fira text-xl mt-8">
          <p className="text-sm font-poppins text-white">
            For any queries contact{" "}
            <a className="text-middle" href="mailto:bestoutgoing@psgtech.ac.in">
              bestoutgoing@psgtech.ac.in
            </a>
          </p>
          <p className="text-sm font-poppins text-white mt-2">
            For tutorial{" "}
            <a
              className="text-middle"
              href="https://tutorialforstudents.netlify.app"
              target="_blank"
              rel="noreferrer"
            >
              Click here
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

const SelectionSection = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full lg:w-7/12 h-full py-16 p-8 lg:pl-0 lg:pr-[calc(100vw/12)] flex flex-col justify-center">
      <div className="hidden lg:block mb-8 w-[60%] ml-auto mr-auto h-48 bg-[url(https://i.ibb.co/g5dpnYg/bogs.jpg)] bg-cover rounded-xl shadow-md bg-center"></div>

      <div className="w-full lg:w-[60%] mx-auto">
        <Heading>Select Category</Heading>

        <div className="flex flex-col space-y-6 mt-8">
          <SelectionButton
            text="Best Outgoing Student"
            description="Apply for the Best Outgoing Student Award"
            icon={<FaTrophy />}
            onClick={() => navigate("/login")}
          />
          <SelectionButton
            text="Tekmusic Awards"
            description="Apply for the Tekmusic Awards"
            icon={<FaMusic />}
            onClick={() => (window.location.href = "https://tekmusicawards.psgtech.ac.in")}
          />
          <SelectionButton
            text="Sports Awards"
            description="Apply for the Sports Awards"
            icon={<FaMedal />}
            onClick={() => (window.location.href = "https://tekmusicawards.psgtech.ac.in/sports")}
          />
        </div>
      </div>
    </section>
  );
};

const SelectionButton = ({ text, description, icon, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="group relative flex items-center p-6 bg-white border-2 border-slate-100 rounded-xl shadow-sm hover:shadow-xl hover:border-orange transition-all duration-300 text-left w-full"
    >
      <div className="bg-slate-50 p-4 rounded-full text-pacific group-hover:bg-orange group-hover:text-white transition-colors duration-300 text-2xl">
        {icon}
      </div>
      <div className="ml-6 flex-1">
        <h3 className="text-xl font-fira font-bold text-slate-800 group-hover:text-pacific transition-colors">
          {text}
        </h3>
        <p className="text-sm text-slate-500 font-poppins mt-1 group-hover:text-slate-600">
          {description}
        </p>
      </div>
      <div className="opacity-0 group-hover:opacity-100 transition-opacity text-orange font-bold text-xl pr-4">
        ➔
      </div>
    </button>
  );
};

export default SelectionPage;
